import * as React from 'react'
import StandardInput from '../components/standard-input'
import Validation from '../../common/modules/validation/rules'
import Recaptcha from '../components/recaptcha'
import CheckboxInput from '../components/checkbox-input'
import StepTitle from '../components/step-title'
import SubHeader from '../components/sub-header'
import StepBlock from '../components/step-block'
import Button from '../components/button'
import { withNavigation } from '../modules/navigation'
import { withRouteBlocker } from '../modules/route-blocker'
import { withScrollToTop } from '../../common/modules/scroll-to-top'
import { withConfig } from '../../common/modules/config'

@withNavigation
@withRouteBlocker
@withScrollToTop
@withConfig
class PaymentOffline extends React.Component<any, any>{


    componentDidMount(){
        this.props.actions.navigation.setCloseWarning(false)

        const config = this.props.config;

        //GA Ecommerce tracking for Offline payments

        // Includes Coverage Type for Contents 
        if(config.project == 'contents'){
        window["dataLayer"] = window["dataLayer"] || [];
        window["dataLayer"].push({
            'event': 'paymentOfflineSubmitted', 
            'transactionId': this.props.fields.quoteNumber,         // String - Quote number
            'transactionAffiliation': 'BPay/EFT',                   // String - Payment method
            'transactionTotal': this.props.fields.totalPayable,     // Numeric - Total amount paid
            'transactionProducts':[{
                'sku': this.props.fields.quoteNumber,               // String - Quote number
                'name': this.props.fields.coverageType+" " +config.project,                    // String - Product name
                'category': config.project,                           // String - Product category
                'price': this.props.fields.totalPayable,            // Numeric - Total amount paid
                'quantity': 1                                       // Integer - Leave set to 1
            }]
        });
        }

        //Coverage type need not be displayed for other products
        else{
            window["dataLayer"] = window["dataLayer"] || [];
            window["dataLayer"].push({
                'event': 'paymentOfflineSubmitted', 
                'transactionId': this.props.fields.quoteNumber,         // String - Quote number
                'transactionAffiliation': 'BPay/EFT',                   // String - Payment method
                'transactionTotal': this.props.fields.totalPayable,     // Numeric - Total amount paid
                'transactionProducts':[{
                    'sku': this.props.fields.quoteNumber,               // String - Quote number
                    'name': config.project,                             // String - Product name
                    'category': config.project,                           // String - Product category
                    'price': this.props.fields.totalPayable,            // Numeric - Total amount paid
                    'quantity': 1                                       // Integer - Leave set to 1
                }]
            });

        }
    }




    render(){
        return (
            <div className="row">
                <StepTitle>Thank you for choosing CHU.</StepTitle>
                
                <StepBlock>
                    <h4>A Tax Invoice is on the way and will be in your inbox soon. Please follow the instructions on the tax invoice to pay for your policy.</h4>
                </StepBlock>

                <Button.Container>
                    <a href={ this.props.config.paymentSuccessRedirect  } className="btn btn-primary btn-lg mt-2">Return Home</a>
                </Button.Container>
            </div>
        )
    }

}


export default PaymentOffline;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/routes/payment-offline.tsx